const env = process.env.NODE_ENV || "development";

const domainEnvironment = {
  development: {
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName:"",
  },
  production: {
      domainAdminSide: "https://admin.backan.cgis.asia",
      domainUserSide: "https://backan.cgis.asia",
      domainName:"backan.cgis.asia",
  },
};

module.exports = domainEnvironment[env];
